export const NUCLEUS_ADMIN_LOCATION_ID = 40000012;
